<template>
  <v-container fluid>
    <v-col align="center">
      <v-col cols="6">
        <v-icon size="80px" color="primary">mdi-alpha-p-circle</v-icon>
      </v-col>
      <v-col cols="6">
        <h2>
          Welcome back to <span style="color: #006d77">P.I.M.S</span> Dashboard
        </h2>
      </v-col>
      <v-col cols="6">
        <h4>Please, Select a pandemic to Continue</h4>
      </v-col>
      <v-col cols="4">
        <v-select
          :items="pandemics"
          menu-props="auto"
          label="Select"
          hide-details
          prepend-icon="mdi-alpha-p-circle"
          single-line
          @change="select_pandemic"
        >
        </v-select>
      </v-col>
    </v-col>
    
  </v-container>
</template>

<script>
export default {
  data: () => ({
    pandemics: ["Covid 19", "Swine Flu", "HIV", "SARS"],
    
  }),

  methods: {
    select_pandemic(e) {
      if (e.localeCompare("Covid 19") == 0) {
        this.$router.push("Dashboard");
      }
      else if (e.localeCompare("Swine Flu") == 0) {
        this.$router.push("Dashboard2");
      }
    },
  },
};
</script>